module.exports = __webpack_public_path__ + "static/scale-model-of-staten-island-children's-museum-in-newark-new-jersey-0a76731431fefd024bc8d1990c61fb5e.png";